import { render, staticRenderFns } from "./ViewDataSources.vue?vue&type=template&id=6555442a"
import script from "./ViewDataSources.vue?vue&type=script&lang=js"
export * from "./ViewDataSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports